<template>
  <div v-if="!applicationData">
    <div class="text-center">
      <h1>{{ $t('application.resumeApplication') }}</h1>
    </div>
    <div
      class="content-box content-box__color-secondary content-box__dense mt-8 pt-16"
    >
      <v-row>
        <v-col>
          <p>{{ $t('application.resumeApplicationInfo') }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            outlined
            flat
            :name="$t('application.emailAddress')"
            :label="$t('application.emailAddress')"
            hide-details="auto"
            v-model="accessEmail"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            outlined
            flat
            name="Token"
            label="Token"
            hide-details="auto"
            v-model="accessToken"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="d-block d-md-flex align-center justify-end">
            <v-btn @click="requestApplication">Bewerbung weiterführen</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
  <apply-form
    :jobofferId="applicationData?.jobofferId"
    :applicationData="applicationData"
    v-else
  />
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { mapActions } from 'vuex';
import { eventBus } from '@/event-bus.js';

import applyForm from '@/components/application/apply-form.vue';
import i18n from '@/i18n';

extend('required', {
  ...required,
  message: i18n.t('validation.fieldIsMandatory')
});

export default {
  data: () => ({
    accessEmail: '',
    accessToken: '',
    applicationData: null,
    showErrorAlert: false,
    errorAlertMessage: ''
  }),

  methods: {
    ...mapActions('applicationModule', {
      loadApplicationData: 'loadApplicationData'
    }),

    async requestApplication() {
      this.showErrorAlert = true;
      this.errorAlertMessage = '';
      const applicationId = this.$route.params.applicationId;
      const result = await this.loadApplicationData({
        email: this.accessEmail,
        applicationId: applicationId,
        token: this.accessToken
      });

      if (result.errorCode) {
        eventBus.$emit(
          'errorMessage',
          this.$t(`application.errors.${result.errorCode}`)
        );

        this.showErrorAlert = true;
        this.errorAlertMessage = this.$t(
          `application.errors.${result.errorCode}`
        );
      } else {
        const applicationData = result.applicationData;
        applicationData.sourceApplicationId = applicationId;
        this.applicationData = applicationData;
      }
    }
  },

  components: {
    applyForm
  }
};
</script>
